import {
  Button,
  Card,
  Dialog,
  Input,
  Message,
  Radio,
  Select,
  Table,
} from '@alifd/next';
import { Cascader, DatePicker, Form } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_TW';
import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';

import DownloadButton from '@/components/UI/DownloadButton';
import EditDocument from '@/components/UI/EditDocument';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;
const Option = Select.Option;

const DownloadManagementAnnualMaintenanceExcel = ({
  example = false,
  children,
}) => (
  <DownloadButton
    {...{
      url: '/ezcon/api/getExampleOrRealDataExcel',
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      params: {
        excelName: 'managementAnnualMaintenanceExcel',
        example,
      },
      fileName: `維運管理年度維護計畫表單_${moment().format('YYYYMMDD')}.xlsx`,
      responseFileType: 'blob',

      buttonProps: {
        type: 'secondary',
      },
    }}
  >
    {children}
  </DownloadButton>
);

const MaintainPlanList = ({
  backStageUpdateTrigger,
  setBackStageUpdateTrigger,
}) => {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const communityDevice = client.service('communityDevice');
  const annualMaintainBudget = client.service('annualMaintainBudget');
  const [communityDeviceDialog, setCommunityDeviceDialog] = useState(false);
  const [communityDeviceArr, setCommunityDeviceArr] = useState([]);
  const [communityDeviceUpdate, setCommunityDeviceUpdate] = useState({});
  const [communityDeviceStatus, setCommunityDeviceStatus] = useState('insert');
  const [annualMaintainBudgetArr, setAnnualMaintainBudgetArr] = useState([]);
  const [
    annualMaintainBudgetRecordDialog,
    setAnnualMaintainBudgetRecordDialog,
  ] = useState(false);
  const [annualMaintainBudgetStatus, setAnnualMaintainBudgetStatus] =
    useState('insert');
  const [recordIndex, setRecordIndex] = useState('');
  const [recordOld, setRecordOld] = useState({});
  const [annualMaintainBudgetDialog, setAnnualMaintainBudgetDialog] =
    useState(false);
  const [currentCycle, setCurrentCycle] = useState('year');

  const getMaintainTimeOptions = useCallback((cycle) => {
    const yearOptions = Array(12)
      .fill(0)
      .map((_, i) => {
        return {
          value: `${i + 1}`,
          label: `${i + 1}月`,
          children: Array(moment().set('month', i).daysInMonth())
            .fill(0)
            .map((_2, j) => ({
              value: `${j + 1}`,
              label: `${i + 1}月${j + 1}日`,
            })),
        };
      });
    const monthOptions = Array(31)
      .fill(0)
      .map((_, i) => ({
        value: `${i + 1}`,
        label: `${i + 1}日`,
      }));
    const weekOptions = Array(7)
      .fill(0)
      .map((_, i) => ({
        value: i.toString(),
        label: moment().weekday(i).format('dddd'),
      }));
    switch (cycle) {
      case 'year':
        return yearOptions;
      case 'month':
        return monthOptions;
      case 'week':
        return weekOptions;
      default:
        return [];
    }
  }, []);

  const handleFieldsChange = useCallback(
    (changedFields) => {
      const name = changedFields[0].name[0];
      const value = changedFields[0].value;
      if (name === 'maintainCycle') {
        form.setFieldValue('maintainTime', []);
        setCurrentCycle(value);
      }
    },
    [form]
  );

  useEffect(() => {
    communityDevice
      .find({ query: { deviceType: '非消耗品' } })
      .then((result) => {
        setCommunityDeviceArr(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        '/ezcon/api/postMongoAggregate',
        {
          aggregate: [
            {
              $addFields: {
                deviceId: { $toObjectId: '$deviceId' },
              },
            },
            {
              $lookup: {
                from: 'communityDevice',
                localField: 'deviceId',
                foreignField: '_id',
                as: 'communityDevice',
              },
            },
          ],
          service: 'annualMaintainBudget',
        },
        {
          headers: {
            authorization: localStorage.getItem('feathers-jwt'),
          },
        }
      )
      .then((result) => {
        setAnnualMaintainBudgetArr(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [backStageUpdateTrigger, communityDevice]);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  const onFinish = (value) => {
    const newDeviceObject = value;
    newDeviceObject.maintainRecords = [];
    newDeviceObject.maintainBalance = value.maintainExpenses;
    newDeviceObject.maintainStartYear = value.contractTime
      .startOf('y')
      .valueOf();
    newDeviceObject.maintainEndYear = value.contractTime.endOf('y').valueOf();
    newDeviceObject.maintainTime = value.maintainTime.sort((a, b) =>
      a.join('').localeCompare(b.join(''))
    );
    if (communityDeviceStatus === 'insert') {
      annualMaintainBudget
        .create(newDeviceObject)
        .then(() => {
          Message.success('新增成功');
          form.resetFields();
          setCommunityDeviceDialog(false);
          setBackStageUpdateTrigger({});
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      annualMaintainBudget
        .patch(communityDeviceUpdate._id, newDeviceObject)
        .then(() => {
          Message.success('修改成功');
          form.resetFields();
          setCommunityDeviceDialog(false);
          setBackStageUpdateTrigger({});
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const onFinishRecord = (value) => {
    let newRecordObject = [...communityDeviceUpdate.maintainRecords];
    if (annualMaintainBudgetStatus === 'insert') {
      newRecordObject = [
        ...newRecordObject,
        {
          ...value,

          createdTime: moment().valueOf(),
        },
      ];
    } else {
      newRecordObject[recordIndex] = {
        ...newRecordObject[recordIndex],
        ...value,
      };
    }

    annualMaintainBudget
      .patch(communityDeviceUpdate._id, {
        maintainRecords: newRecordObject,
        maintainBalance:
          annualMaintainBudgetStatus === 'insert'
            ? parseInt(
                communityDeviceUpdate.maintainBalance -
                  value.maintainRecordMoney,
                10
              )
            : parseInt(communityDeviceUpdate.maintainBalance, 10) +
              parseInt(recordOld.maintainRecordMoney, 10) -
              parseInt(value.maintainRecordMoney, 10),
      })
      .then(() => {
        if (annualMaintainBudgetStatus === 'insert') {
          Message.success('新增維護記錄成功');
        } else {
          Message.success('編輯維護記錄成功');
        }

        setBackStageUpdateTrigger({});
        setAnnualMaintainBudgetRecordDialog(false);
        annualMaintainBudget
          .find({ query: { _id: communityDeviceUpdate._id } })
          .then((result) => {
            setCommunityDeviceUpdate(result.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className={styles.functions}>
        <Button
          onClick={() => {
            setCommunityDeviceUpdate({});
            setCommunityDeviceDialog(true);
            setCommunityDeviceStatus('insert');
            form.resetFields();
          }}
        >
          新增
        </Button>
        <DownloadManagementAnnualMaintenanceExcel example>
          下載範例表單
        </DownloadManagementAnnualMaintenanceExcel>
        <DownloadManagementAnnualMaintenanceExcel>
          匯出excel
        </DownloadManagementAnnualMaintenanceExcel>
        <EditDocument name="年度維護計畫" />
      </div>

      {/* 新增修改年度維護列表 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={communityDeviceDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setCommunityDeviceDialog(false);
        }}
        onClose={() => {
          setCommunityDeviceDialog(false);
        }}
      >
        <h1>
          {communityDeviceStatus === 'insert' ? '新增' : '修改'}年度維護預算
        </h1>

        <Form
          form={form}
          name="dynamic_form_item"
          onFinish={onFinish}
          labelAlign="left"
          onFieldsChange={handleFieldsChange}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇設備名稱',
              },
            ]}
            label="設備名稱"
            name="deviceId"
          >
            <Select
              className={styles.options}
              placeholder="請選擇設備名稱"
              aria-label="name is"
            >
              {communityDeviceArr.map((item) => (
                <Option value={item._id} key={item._id}>
                  {item.deviceName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="合約時間"
            name="contractTime"
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇合約時間',
              },
            ]}
          >
            <DatePicker
              picker="year"
              locale={locale}
              disabledDate={(date) => {
                return date.isBefore(moment().endOf('year'));
              }}
            />
          </Form.Item>
          <Form.Item
            label="修繕週期"
            initialValue={currentCycle}
            name="maintainCycle"
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇修繕週期',
              },
            ]}
          >
            <Select>
              <Option value="year">年</Option>
              <Option value="month">月</Option>
              <Option value="week">週</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="修繕時間"
            name="maintainTime"
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇修繕時間',
              },
            ]}
          >
            <Cascader
              expandTrigger="hover"
              options={getMaintainTimeOptions(currentCycle)}
              multiple
            />
          </Form.Item>
          <Form.Item
            label="維護預算"
            name="maintainExpenses"
            rules={[
              {
                required: true,
                message: '請選擇維護預算',
              },
            ]}
            {...formItemLayout}
          >
            <Input innerAfter="元" />
          </Form.Item>
        </Form>
      </Dialog>

      {/* 查看維修記錄 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={annualMaintainBudgetDialog}
        onOk={() => {
          setAnnualMaintainBudgetDialog(false);
        }}
        onCancel={() => {
          setAnnualMaintainBudgetDialog(false);
        }}
        onClose={() => {
          setAnnualMaintainBudgetDialog(false);
        }}
      >
        <h1>查看年度維護記錄</h1>
        <Button
          type="normal"
          onClick={() => setAnnualMaintainBudgetRecordDialog(true)}
          style={{ marginBottom: '20px' }}
        >
          新增維護記錄
        </Button>
        <Table dataSource={communityDeviceUpdate.maintainRecords}>
          <Table.Column
            dataIndex="createdTime"
            title="維修時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />
          <Table.Column dataIndex="maintainRecordStatus" title="設備狀態" />
          <Table.Column
            dataIndex="maintainRecordMoney"
            title="維護費用"
            cell={(value) => `${value}元`}
          />
          <Table.Column dataIndex="maintainRecordText" title="備註" />
          <Table.Column dataIndex="maintainRecordPerson" title="維護人員" />
          <Table.Column
            title="操作"
            width={100}
            cell={(_value, index, record) => {
              return (
                <div className={styles.btnGroup}>
                  <Button
                    type="normal"
                    onClick={() => {
                      setAnnualMaintainBudgetStatus('update');
                      form1.setFieldsValue(record);
                      setRecordOld(record);
                      setRecordIndex(index);
                      setAnnualMaintainBudgetRecordDialog(true);
                    }}
                  >
                    編輯
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      const newObject = [
                        ...communityDeviceUpdate.maintainRecords,
                      ];
                      newObject.splice(index, 1);

                      annualMaintainBudget
                        .patch(communityDeviceUpdate._id, {
                          maintainRecords: newObject,
                          maintainBalance:
                            parseInt(
                              communityDeviceUpdate.maintainBalance,
                              10
                            ) + parseInt(record.maintainRecordMoney, 10),
                        })

                        .then(() => {
                          Message.success('刪除成功');
                          setBackStageUpdateTrigger({});
                          annualMaintainBudget
                            .find({ query: { _id: communityDeviceUpdate._id } })
                            .then((result) => {
                              setCommunityDeviceUpdate(result.data[0]);
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        })
                        .catch((error) => console.log(error));
                    }}
                    warning
                  >
                    刪除
                  </Button>
                </div>
              );
            }}
          />
        </Table>
      </Dialog>

      {/* 新增編輯維修記錄 */}
      <Dialog
        name="dynamic_form_item"
        hasMask
        className={styles.dialog}
        visible={annualMaintainBudgetRecordDialog}
        onOk={() => {
          form1.submit();
        }}
        onCancel={() => {
          setAnnualMaintainBudgetRecordDialog(false);
        }}
        onClose={() => {
          setAnnualMaintainBudgetRecordDialog(false);
        }}
      >
        <h1>
          {annualMaintainBudgetStatus === 'insert' ? '新增' : '編輯'}維修記錄
        </h1>
        <Form
          form={form1}
          onFinish={onFinishRecord}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            label="設備狀態"
            name="maintainRecordStatus"
            rules={[
              {
                required: true,
                message: '請選擇維護狀態',
              },
            ]}
            {...formItemLayout}
          >
            <RadioGroup aria-labelledby="groupId">
              <Radio value="良">良</Radio>
              <Radio value="普">普</Radio>
              <Radio value="劣">劣</Radio>
            </RadioGroup>
          </Form.Item>
          <Form.Item
            label="備註"
            name="maintainRecordText"
            rules={[
              {
                required: false,
                message: '請輸入維護原因',
              },
            ]}
            {...formItemLayout}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="維護費用"
            name="maintainRecordMoney"
            rules={[
              {
                required: true,
                message: '請輸入維護費用',
              },
            ]}
            {...formItemLayout}
          >
            <Input innerAfter="元" />
          </Form.Item>
          <Form.Item
            label="維護人員"
            name="maintainRecordPerson"
            rules={[
              {
                required: true,
                message: '請輸入維護人員',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
        </Form>
      </Dialog>

      <br />
      <br />
      <Card free>
        <Card.Content>
          <Table dataSource={annualMaintainBudgetArr}>
            <Table.Column
              title="設備名稱"
              width={150}
              cell={(_value, _index, record) => (
                <div>{record.communityDevice[0].deviceName}</div>
              )}
            />
            <Table.Column
              title="設備編號"
              width={150}
              cell={(_value, _index, record) => (
                <div>{record.communityDevice[0].deviceNumber}</div>
              )}
            />

            <Table.Column
              title="修繕時間"
              width={150}
              cell={(_, _2, record) => {
                let displayTime = '';
                if (record.maintainCycle === 'year') {
                  const times = record.maintainTime;
                  displayTime = `${times
                    .map((t) => {
                      if (t.length === 1) {
                        return `${t[0]}月`;
                      } else {
                        return `${t[0]}月${t[1]}日`;
                      }
                    })
                    .join('、')}`;
                } else if (record.maintainCycle === 'month') {
                  const times = record.maintainTime;
                  displayTime = `每月：${times
                    .map((t) => `${t[0]}日`)
                    .join('、')}`;
                } else if (record.maintainCycle === 'week') {
                  const times = record.maintainTime;
                  displayTime = `每週：${times
                    .map((t) => moment().set('weekday', t[0]).format('dddd'))
                    .join('、')}`;
                } else {
                  displayTime = '無設定';
                }
                return displayTime;
              }}
            />
            <Table.Column
              title="維護廠商"
              width={100}
              cell={(_value, _index, record) => {
                return (
                  <div>{record.communityDevice[0]?.deviceVendor[0]?.name}</div>
                );
              }}
            />
            <Table.Column
              title="維護合約期間"
              width={100}
              cell={(_value, _index, record) =>
                `${moment(record.maintainStartYear).format('YYYY')}年`
              }
            />
            <Table.Column
              title="維護預算"
              width={100}
              dataIndex="maintainExpenses"
              cell={(value) => `${value}元`}
            />
            <Table.Column
              title="剩餘費用"
              width={100}
              dataIndex="maintainBalance"
              cell={(value) => `${value}元`}
            />
            <Table.Column
              title="操作"
              width={100}
              cell={(_value, _index, record) => {
                return (
                  <div className={styles.btnGroup}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setCommunityDeviceUpdate(record);
                        setAnnualMaintainBudgetDialog(true);
                      }}
                    >
                      查看年度維護記錄
                    </Button>

                    <Button
                      type="normal"
                      onClick={() => {
                        setCommunityDeviceStatus('update');
                        form.setFieldsValue({
                          ...record,
                          contractTime: moment(record.maintainStartYear),
                        });
                        setCommunityDeviceUpdate(record);
                        setCommunityDeviceDialog(true);
                      }}
                    >
                      編輯
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        annualMaintainBudget
                          .remove(record._id)
                          .then(() => {
                            Message.success('刪除成功');
                            setBackStageUpdateTrigger({});
                          })
                          .catch((error) => console.log(error));
                      }}
                      warning
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default MaintainPlanList;
